import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc86e76"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "User Belt Achievement Queue", -1 /* HOISTED */))
const _hoisted_2 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "UserID"),
    /*#__PURE__*/_createElementVNode("th", null, "Username"),
    /*#__PURE__*/_createElementVNode("th", null, "Full Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Old Annual Belt"),
    /*#__PURE__*/_createElementVNode("th", null, "Old Running Belt"),
    /*#__PURE__*/_createElementVNode("th", null, "New Annual Belt"),
    /*#__PURE__*/_createElementVNode("th", null, "New Running Belt"),
    /*#__PURE__*/_createElementVNode("th", null, "Time Last Sale Added"),
    /*#__PURE__*/_createElementVNode("th", null, "Estimated Finish Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Complete"),
    /*#__PURE__*/_createElementVNode("th", null, "Cancel")
  ])
], -1 /* HOISTED */))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.userBeltAchievements.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userBeltAchievements, (beltAchievement) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: beltAchievement.UserID
              }, [
                _createElementVNode("td", null, _toDisplayString(beltAchievement.UserID), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.UserName), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.UserFullName), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.UserEmail), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.OldAnnualBelt.DisplayColor), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.OldRunningRateBelt.DisplayColor), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.NewAnnualBelt.DisplayColor), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.NewRunningRateBelt.DisplayColor), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.SaleAddedTime.toLocaleString('en-GB')), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(beltAchievement.EstimatedFinishTime.toLocaleString('en-GB')), 1 /* TEXT */),
                _createElementVNode("td", {
                  class: "belt-achievement-button",
                  onClick: ($event: any) => (_ctx.completeBeltAchievement(beltAchievement.UserID))
                }, " ✓ ", 8 /* PROPS */, _hoisted_4),
                _createElementVNode("td", {
                  class: "belt-achievement-button",
                  onClick: ($event: any) => (_ctx.cancelBeltAchievement(beltAchievement.UserID))
                }, " ✕ ", 8 /* PROPS */, _hoisted_5)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, " No user belt achievements in the queue. "))
  ], 64 /* STABLE_FRAGMENT */))
}